import { Validator } from 'vee-validate'
import unique from './unique'
import cnpj from './cnpj'
import cep from './cep'
import cpf from './cpf'

Validator.extend('unique', unique, {
  immediate: false,
  paramNames: ['attribute', 'collection', 'id']
})

Validator.extend('cnpj', cnpj)
Validator.extend('cep', cep)
Validator.extend('cpf', cpf)



// WEBPACK FOOTER //
// ./src/config/validations/index.js